import { ENDPOINTS } from '../../apis/endpoints';
import { apiSlice } from '../../app/api/apiSlice';
import { selectCurrentUserEmpCode, setCurrentTeam } from '../Auth/authSlice';

// empcode done
export const profileApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
 fetchProfile: builder.query({
  query: (empCode) => `${ENDPOINTS.EMPLOYEE.PROFILE_BY_EMPCODE}${empCode}`,
  transformResponse: (response) => {
    const fileName = response.employeePhotoPath ? response.employeePhotoPath.split('/').pop() : null;
    const encodedFileName = encodeURIComponent(fileName);
    const data = { ...response, employeePhotoPath: `${process.env.REACT_APP_BASE_PHOTO_URL}${encodedFileName}` };
    return data
    
  },
  providesTags: ({ empCode }) => {
    return empCode
      ? [
          { type: 'Profile', id: 'LIST' },
          { type: 'Profile', id: empCode },
        ]
      : [{ type: 'Profile', id: 'LIST' }];
  },
  async onQueryStarted(args, { dispatch, getState, queryFulfilled }) {
    const currentUserCode = selectCurrentUserEmpCode(getState());
    const { data } = await queryFulfilled;
    if (currentUserCode === args) {
      dispatch(setCurrentTeam(data)); // This `data` is already transformed
    }
  },
}),
    getUserStatus: builder.query({
      query: (empCode) => `${ENDPOINTS.EMPLOYEE.STATUS}${empCode}`,
      providesTags: (result, error, empCode) => [{ type: 'Profile', id: empCode }],
    }),
    updateProfile: builder.mutation({
      query: ({ empCode, data }) => ({
        url: `${ENDPOINTS.EMPLOYEE.UPDATE_BY_EMPCODE}${empCode}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { empCode }) => [{ type: 'Profile', id: empCode }],
    }),
    addProfileData: builder.mutation({
      query: ({ empCode, sectionKey, newData }) => ({
        url: `${ENDPOINTS.EMPLOYEE.ADD_PROFILE_DATA}${empCode}`,
        method: 'POST',
        body: { empCode, sectionKey, newData },
      }),
      invalidatesTags: (result, error, { empCode }) => [{ type: 'Profile', id: empCode }],
    }),
    uploadPhoto: builder.mutation({
      query: ({ empCode, formData }) => ({
        url: `${ENDPOINTS.USER.UPLOAD_PHOTO}${empCode}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: (result, error, { empCode }) => [{ type: 'Profile', id: empCode }],
    }),
    getTeam: builder.query({
      query: (empCode) => `${ENDPOINTS.EMPLOYEE.TEAM}${empCode}`,
      providesTags: (result, error, empCode) => [{ type: 'Profile', id: empCode }],
    }),
  }),
});

export const {
  useFetchProfileQuery,
  useGetUserStatusQuery,
  useUpdateProfileMutation,
  useAddProfileDataMutation,
  useUploadPhotoMutation,
  useGetTeamQuery,
} = profileApiSlice;

export const getMasterDataSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMasterData: builder.query({
      query: ({ type, technologyId }) => ({
        url: ENDPOINTS.EMPLOYEE.MASTER_DATA,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Type: type,
          TechnologyId: technologyId,
        },
      }),
    }),
  }),
});

export const { useGetMasterDataQuery } = getMasterDataSlice;
